require('@telefonica/coco.lib-staticAt');
require('@telefonica/coco.lib-staticAei/src/static-aei/indexApp.js');
//hoja de estilos del cntr
require('./css/loginAppO2.css');


var angular = global.angular;
var T3_COMUN_APP = global.T3_COMUN_APP;

var CNT = {
  name: 'loginAppO2',
  ngModule: {}
};


CNT.ngModule = angular.module(CNT.name, [T3_COMUN_APP.NAME, 'ui.router', 'ui.router.state.events', 'gettext', 'oc.lazyLoad', 'ui.bootstrap', 'ui.date', 'ngResource']);
CNT.init =  function () {
    angular.bootstrap(document, [CNT.name]);
};

global.CNT = CNT;

var context = require.context('./', false, /^.*_(constant|controller|directive|service|model).js$/);
context.keys().forEach(context); 

require('./app');

if (!window.modeTest) {
 	 CNT.init() 
}